import { ColorSwatch, IconImage } from 'libs/athos/components/collection/filters/FilterCustomisations'
import { FilterCollapse } from 'libs/athos/components/collection/filters/FilterCollapse'
import { FilterInputSlider } from 'libs/athos/components/collection/filters/FilterSlider'
import { UniversalSizeFilter } from 'libs/athos/components/collection/filters/UniversalSizeFilter'
import { useFetchedFilter, useFilterCustomizations, useFilterValues, useActiveFilterLabel } from 'libs/athos/components/collection/filters/FilterHooks'
import clsx from 'clsx'

export function FilterItem({ filter, activeFilters, fetchedFilters, onFilter, onRemove }) {
  if (!filter) return null

  const fetchedFilter = useFetchedFilter(filter, fetchedFilters)
  const filterCustomizations = useFilterCustomizations(filter.field)
  const values = useFilterValues(filter, activeFilters, fetchedFilter, filterCustomizations)
  const activeFilterLabel = useActiveFilterLabel(filter, values, fetchedFilter, activeFilters)

  const isSizeFilter =
    filter.field === 'ss_combined_sizes' ||
    values.some(
      (value) =>
        typeof value.label === 'string' &&
        (value.label.includes(',') || /^[MWKA]\s*\//i.test(value.label))
    )

  const FilterContent = () => {
    if (isSizeFilter) {
      return <UniversalSizeFilter values={values} onFilter={onFilter} />
    }

    switch (filter.type) {
      case 'slider':
        return <FilterInputSlider filter={filter} fetchedFilter={fetchedFilter} activeFilters={activeFilters} onFilter={onFilter} onRemove={onRemove} />
      case 'list':
        if (!values.length) return null
        return <FilterInputs field={filter.field} values={values} onFilter={onFilter} />
      default:
        if (!values.length) return null
        return <FilterInputs field={filter.field} values={values} onFilter={onFilter} />
    }
  }

  return (
    <FilterCollapse
      label={filter.label}
      activeFilterLabel={activeFilterLabel}
      valueType={filter.type === 'slider' ? undefined : 'number'}
    >
      <div className="flex flex-col px-margin pb-1">
        {FilterContent()}
      </div>
    </FilterCollapse>
  )
}

const FilterInputs = ({ values, onFilter, field }) => {
  return (
    <>
      {values.map((item) => {
        return (
          <div className="group/filter-item relative flex w-full cursor-pointer items-start gap-x-0.5 min-h-[44px] py-0.5" key={item.value}>
            <input
              id={item.value}
              className={clsx(
                'peer field-checkbox shrink-0 disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 group-hover/filter-item:border-primary group-hover/filter-item:bg-primary',
                item.color || item.icon
                  ? 'overflow-hidden absolute z-2 !size-1.5 rounded-full opacity-0 inset-tl'
                  : ''
              )}
              type="checkbox"
              name={field}
              checked={item.checked}
              disabled={item.disabled}
              onClick={() => onFilter(item.value)}
              aria-label={item.label}
            />
            <label
              for={item.value}
              className="flex grow cursor-pointer items-center peer-disabled:pointer-events-none peer-disabled:cursor-not-allowed peer-disabled:opacity-50 peer-checked:[&_.swatch-inner]:outline-brand-primary"
            >
              {item.color && <ColorSwatch color={item.color} />}
              {item.icon && <IconImage iconObject={item.icon} />}
              <div className="grow flex items-center justify-between gap-x-0.5">
                <span className="paragraph-s text-type-black-secondary">
                  {item.label}
                </span>
                <span className="shrink-0 paragraph-s text-type-black-tertiary">({item.count ?? 0})</span>
              </div>
            </label>
          </div>
        )
      })}
    </>
  )
}
